/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentSupport {
    constructor(cscom) {
        if (!(this instanceof CurrentSupport)) {
            return new CurrentSupport(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/support/view', null, data);
    }

   
}
